/**
 * THE DELIVERY DATE IS A CALENDAR DAY, NOT A MOMENT - AND THAT DECIDES HOW IT IS RENDERED.
 *
 * Both clients send local midnight of the day the submitter picked, converted to UTC
 * (medeffectmobile's orderDate.js, and the web's `new Date("YYYY-MM-DDT00:00:00")`, which the spec
 * parses as LOCAL). From any US zone that lands at 04:00-08:00Z on the SAME calendar day.
 *
 * So rendering it in the VIEWER's timezone is wrong. An order submitted from Eastern is stored at
 * 04:00Z; an admin in Pacific renders that as 21:00 the PREVIOUS day and reads a delivery date one
 * day early. The bug would only appear for some viewers, on some orders - the worst kind.
 *
 * RENDERED IN UTC, and not merely because UTC is neutral: it is what the VENDOR'S FORM SAYS. The
 * BLS template prints this field with formatFormDate(), which uses server-local getDate(), and
 * Render runs UTC. So UTC here means the admin sees the same date printed on the order form the
 * vendor received - which is the whole point of looking it up.
 *
 * LEGACY ORDERS ARE NOT REPAIRED HERE. Records predating the local-midnight fix carry the
 * wall-clock time the screen was opened (real values in the corpus: 11:02Z, 13:59Z, 20:02Z,
 * 04:52Z), and for a late-evening submission the stored UTC day is already one day past the day
 * that was picked. That day is what went to the vendor, so it is the honest thing to display;
 * guessing the original intent from a timestamp would just invent a different wrong answer.
 *
 * The ORDER date is deliberately NOT treated this way - createdAt is a genuine instant, "when this
 * happened", and belongs in the reader's own timezone.
 */

/**
 * "Aug 30, 2026" for a stored delivery date, or null when the order has none - 21 of the 29 orders
 * predating the required-delivery-date rule have no value at all, so absence is ordinary and must
 * not render as "Invalid Date".
 */
export function formatDeliveryDate(value, locale = 'en-US') {
  if (!value) return null;
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toLocaleDateString(locale, {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC',
  });
}
